import { useDeleteCompanyApi } from '../api/delete-company-api'
import { useEffect } from 'react'
import { notification } from '@/shared/helpers/notificationMessages'
import { useTranslation } from 'react-i18next'
import { errorHandler } from '@/shared/lib/errorHandler'

export const useDeleteCompany = () => {
  const {
    mutateAsync,
    isPending: isLoadingDelete,
    isSuccess: isSuccessDelete,
  } = useDeleteCompanyApi()
  const { t } = useTranslation(['common'])

  const handleDeleteCompany = async (id: number, handleClose: () => void) => {
    try {
      await mutateAsync(id)
    } catch (error) {
      errorHandler(error, t('notification_messages.delete_company_error'))
    } finally {
      handleClose()
    }
  }

  useEffect(() => {
    if (isSuccessDelete) {
      notification.success(
        t('common:notification_titles.success'),
        t('common:notification_messages.delete_company_success'),
      )
    }
  }, [isSuccessDelete])

  return {
    isLoadingDelete,
    handleDeleteCompany,
  }
}
